




function setActiveLink (links : NodeListOf<HTMLAnchorElement>) : HTMLAnchorElement {
    // Return if links is empty
    if (!links || links.length < 1) throw "No links in parameter";

    // First link active on load
    let activeLink : HTMLAnchorElement = links[0];

    links.forEach( (link : HTMLAnchorElement) => {
        link.classList.remove('active');

        const section : HTMLElement | null = document.querySelector(link.hash);
        if ( section && section.offsetTop - window.scrollY <= 0 ) {
            activeLink = link;
        }
    });

    activeLink.classList.add('active');

    return activeLink;
}


// Horizontal scroll to link in quicknav
function scrollToLink (activeLink : HTMLAnchorElement) {
    const quicknav : HTMLElement | null = document.querySelector('.quicknav-holder');

    if ( activeLink && quicknav ) {
        quicknav.scrollTo({
            left: activeLink.offsetLeft - 20,
            behavior: 'smooth'
        });
    }
}


// Scroll window to section
function scrollToSection ( window : Window, link : HTMLAnchorElement) {
    if (!link) return;

    const section : HTMLElement | null = document.querySelector(link.hash);

    if ( section ) {
        window.scrollTo({
            top: section.offsetTop,
            behavior: 'smooth'
        });
    }
}





export default function setupQuickNav () {

    window.addEventListener('DOMContentLoaded', () => {
        if (!document.querySelector('.quicknav')) return;

        const links : NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.quicknav a');

        setActiveLink(links);

        links.forEach( (link : HTMLAnchorElement) => {
            link.addEventListener('click', evt => {
                evt.preventDefault();

                scrollToSection(window, link);
            });
        });

        window.addEventListener('scroll', () => {
            const activeLink : HTMLAnchorElement = setActiveLink(links);
            scrollToLink(activeLink);
        });
    });
}
